<template>
  <div class="branches-contact" v-if="branches !== []">
    <div class="px-6 py-6 card card-branch-contact branch-contact-bg">
      <h2
        class="has-text-weight-bold has-text-primary has-text-centered is-size-5"
      >
        {{t('branches_contact')}}
      </h2>
      <div class="mt-6 columns is-multiline is-centered">
        <div class="column is-4">
          <div class="field">
            <div class="control select is-fullwidth">
              <select
                required
                v-model="branch"
                @change="()=>{
                  school = null,
                  level = null
                }"
                name="branch"
                class="input form-element line-input is-primary has-text-weight-bold"
              >
                <option :value="null" disabled selected>{{t('choose_branch')}}</option>
                <option v-for="branch in branches" :value="branch" :key="`branch_${branch.id}`">{{branch.name}}</option>
              </select>
              <span class="line-control is-primary"></span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <div class="control select is-fullwidth" >
              <select
                required
                v-model="school"
                name="school"
                class="input form-element line-input is-primary has-text-weight-bold"
                v-if="branch != null"
              >
                <option :value="null" disabled selected>{{t('choose_school')}}</option>
                <option v-for="school in branch.schools" :value="school" :key="`school_${school.id}`">{{school.name}}</option>
              </select>
              <select
                required
                v-model="school"
                name="school"
                class="input form-element line-input is-primary has-text-weight-bold"
                v-else
              >
                <option :value="null" disabled selected>{{t('choose_school')}}</option>
              </select>
              <span class="line-control is-primary"></span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <div class="control select is-fullwidth">
              <select
                required
                v-model="level"
                name="level"
                class="input form-element line-input is-primary has-text-weight-bold"
                v-if="school != null"
              >
                <option :value="null" disabled selected>{{t('choose_level')}}</option>
                <option v-for="level in school.levels" :value="level" :key="`level_${level.id}`">{{level.name}}</option>
              </select>
              <select
                required
                v-model="level"
                name="level"
                class="input form-element line-input is-primary has-text-weight-bold"
                v-else
              >
                <option :value="null" disabled selected>{{t('choose_level')}}</option>
              </select>
              <span class="line-control is-primary"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="button-container">
        <button
          class="button is-primary has-text-weight-bold"
          type="submit"
          :disabled="isDisabled"
          @click="getInfo"
        >
          <i class="ml-2 loader" v-if="loading"></i>
          {{t('contact_info')}}
        </button>
      </div>
    </div>

    <collapse-transition :duration="1000">
      <div
        class="card card-branch-contact has-background-primary"
        v-show="info"
      >      
        <div class="px-6 py-6 has-text-white has-text-weight-bold" v-html="info"></div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
export default {
  name: "BranchesContact",
  components: {
    CollapseTransition,
  },
  props:{
    branches:{
      type: Array,
      required:true,
      default:[]
    },
    lang:{
      type:String,
      required:true,
      default:'ar'
    }
  },
  data() {
    return {
      branch: null,
      school: null,
      level: null,
      info: null,
      loading: false,
      disabled: false,
    };
  },
  mounted() {
		this.$translate.setLang(this.lang);
	},
  computed: {
    isDisabled() {
      let disabled = true;
      if (this.branch === null || this.school === null || this.level === null) {
        disabled = true;
      } else if (this.disabled) {
        disabled = true;
      } else {
        disabled = false;
      }
      return disabled;
    },
  },
  methods: {
    getInfo() {
      if (this.branch && this.school && this.level !== null) {
        this.disabled = true;
        this.loading = true;
        this.info = null;
        setTimeout(() => {
           this.disabled = false;
          this.loading = false;
          this.info = this.level.info;
        }, 500);
        // axios.post("/", "").then(({ data }) => {
        //   this.disabled = false;
        //   this.loading = false;
        //   this.info = "test";
        // });
      }
    },
  },
};
</script>
<style scoped>
label {
  opacity: 0.75;
}
.collpase-transition.is-active {
  display: block;
}
.collpase-transition {
  display: none;
}
</style>
